'use client';

import { ComponentProps } from 'react';

export function HeadphoneIcon({ ...props }: ComponentProps<'svg'>) {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' width='25' height='25' viewBox='0 0 25 25' fill='none' {...props}>
            <g clipPath='url(#clip0_2088_480)'>
                <rect width='25' height='25' fill='white' />
                <path
                    d='M9.375 10.1562C9.375 9.29346 8.67529 8.59375 7.8125 8.59375H7.03125C5.30518 8.59375 3.90625 9.99268 3.90625 11.7188V14.0625C3.90625 15.7886 5.30518 17.1875 7.03125 17.1875H7.8125C8.67529 17.1875 9.375 16.4878 9.375 15.625V10.1562ZM17.9688 17.1875C19.6948 17.1875 21.0938 15.7886 21.0938 14.0625V11.7188C21.0938 9.99268 19.6948 8.59375 17.9688 8.59375H17.1875C16.3247 8.59375 15.625 9.29346 15.625 10.1562V15.625C15.625 16.4878 16.3247 17.1875 17.1875 17.1875H17.9688ZM12.5 0C5.52637 0 0.223633 5.80225 0 12.5V13.2812C0 13.7129 0.349609 14.0625 0.78125 14.0625H1.5625C1.99414 14.0625 2.34375 13.7129 2.34375 13.2812V12.5C2.34375 6.8999 6.8999 2.34375 12.5 2.34375C18.1001 2.34375 22.6562 6.8999 22.6562 12.5H22.6504C22.6543 12.6187 22.6562 20.5918 22.6562 20.5918C22.6562 21.7319 21.7319 22.6562 20.5918 22.6562H15.625C15.625 21.3618 14.5757 20.3125 13.2812 20.3125H11.7188C10.4243 20.3125 9.375 21.3618 9.375 22.6562C9.375 23.9507 10.4243 25 11.7188 25H20.5918C23.0264 25 25 23.0264 25 20.5918V12.5C24.7764 5.80225 19.4736 0 12.5 0Z'
                    fill='currentcolor'
                />
            </g>
            <defs>
                <clipPath id='clip0_2088_480'>
                    <rect width='25' height='25' fill='white' />
                </clipPath>
            </defs>
        </svg>
    );
}
